export default {
  methods: {
    translatedProductName(productName, keyOnly = false) {
      const map = {
        "Setup Guide for Teeth": "setupGuideForTeeth",
        "Shell Guide for Implants": "setupGuideForImplants",
        "Shell Temp Design": "shellTempDesign",
        "DentaTEMP": "shellTempDesign",
        "DentaCAD": "setupGuideForTeeth",
        "DentaWAX": "setupGuideForImplants",
        "dentaBridge": "dentaBridge",
        "DentaBridge": "dentaBridge"
      };

      if (keyOnly) {
        return map[productName];
      }

      if (productName && map[productName]) {
        return this.$t(map[productName]);
      }

      return this.$t("Undefined");
    },
  },
};
